import { toast } from "@/hooks/use-toast"

export const toastHelpers = {
  success: (title: string, description?: string) => {
    return toast({
      title,
      description,
      variant: "success",
      duration: 4000,
    })
  },

  error: (title: string, description?: string) => {
    return toast({
      title,
      description,
      variant: "destructive",
      duration: 6000,
    })
  },

  warning: (title: string, description?: string) => {
    return toast({
      title,
      description,
      variant: "warning", 
      duration: 5000,
    })
  },

  info: (title: string, description?: string) => {
    return toast({
      title,
      description,
      variant: "default",
      duration: 4000,
    })
  },

  apiSuccess: (action: string, entity?: string) => {
    return toastHelpers.success(
      `${action} exitoso`,
      entity ? `${entity} se ${action.toLowerCase()} correctamente.` : undefined
    )
  },

  apiError: (action: string, error?: any, entity?: string) => {
    const errorMessage = error?.message || error?.toString() || 'Ocurrió un error inesperado'
    return toastHelpers.error(
      `Error al ${action.toLowerCase()}`,
      entity ? `No se pudo ${action.toLowerCase()} ${entity}. ${errorMessage}` : errorMessage
    )
  },

  orderCreated: (orderNumber?: string) => {
    return toastHelpers.success(
      "Pedido creado",
      orderNumber ? `El pedido ${orderNumber} se creó correctamente.` : "El pedido se creó correctamente."
    )
  },

  paymentProcessed: (amount?: number) => {
    return toastHelpers.success(
      "Pago procesado",
      amount ? `Pago de $${amount.toFixed(2)} procesado correctamente.` : "Pago procesado correctamente."
    )
  },

  userCreated: (username: string) => {
    return toastHelpers.success(
      "Usuario creado",
      `El usuario "${username}" se creó correctamente.`
    )
  },

  userDeleted: (username: string) => {
    return toastHelpers.success(
      "Usuario eliminado", 
      `El usuario "${username}" se eliminó correctamente.`
    )
  },

  productCreated: (productName: string) => {
    return toastHelpers.success(
      "Producto agregado",
      `"${productName}" se agregó al menú.`
    )
  },

  categoryCreated: (categoryName: string) => {
    return toastHelpers.success(
      "Categoría creada",
      `La categoría "${categoryName}" se creó correctamente.`
    )
  },

  productUpdated: (productName: string) => {
    return toastHelpers.success(
      "Producto actualizado",
      `"${productName}" se actualizó correctamente.`
    )
  },

  productDeleted: (productName: string) => {
    return toastHelpers.success(
      "Producto eliminado",
      `"${productName}" se eliminó del menú.`
    )
  },

  categoryDeleted: (categoryName: string) => {
    return toastHelpers.success(
      "Categoría eliminada",
      `La categoría "${categoryName}" se eliminó correctamente.`
    )
  },

  categoryUpdated: (categoryName: string) => {
    return toastHelpers.success(
      "Categoría actualizada", 
      `La categoría "${categoryName}" se actualizó correctamente.`
    )
  },

  tableCreated: (tableNumber: string) => {
    return toastHelpers.success(
      "Mesa creada",
      `La mesa ${tableNumber} se creó correctamente.`
    )
  },

  tableUpdated: (tableNumber: string) => {
    return toastHelpers.success(
      "Mesa actualizada", 
      `La mesa ${tableNumber} se actualizó correctamente.`
    )
  },

  validationError: (message: string) => {
    return toastHelpers.error(
      "Error de validación",
      message
    )
  },

  networkError: () => {
    return toastHelpers.error(
      "Error de red",
      "Revisa tu conexión e intenta de nuevo."
    )
  },

  permissionDenied: () => {
    return toastHelpers.error(
      "Permiso denegado",
      "No tienes permiso para realizar esta acción."
    )
  }
}
